<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div class="filtroConsolidado vx-row p-4">
          <div class="vx-col lg:w-3/5 w-full">
            <span class="labelFiltro">Selecione um tipo:</span>
            <div class="vx-col gap-4 sm:flex w-full mt-2">
              <v-select
                class="sm:w-1/2 w-full sm:mb-0 mb-3"
                :options="divisoes"
                placeholder="Buscar por assessoria"
                name="Divisao"
                id="Divisao"
                v-model="formFiltro.divisao"
                @input="buscaDadosRegionais()"
              ></v-select>

              <v-select
                multiple
                class="sm:w-1/2 w-full lg:mb-0 mb-3"
                placeholder="Buscar por corretora"
                :options="regionais"
                name="Regional"
                id="Regional"
                v-model="formFiltro.regional"
                @input="buscaDadosConsultor()"
              ></v-select>

              <v-select
                multiple
                class="sm:w-1/2 w-full lg:mb-0 mb-3"
                placeholder="Buscar por usuário"
                :options="consultores"
                name="Consultor"
                id="Consultor"
                v-model="formFiltro.consultor"
              ></v-select>
            </div>
          </div>
          <div class="vx-col lg:w-2/5 w-full">
            <span class="labelFiltro">Selecione um período:</span>
            <div class="vx-col gerar sm:flex gap-4 w-full mt-2">
              <div class="vx-col relative flex gap-4 w-full">
                <datepicker
                  use-utc
                  icon="icon-arrow-right"
                  class="w-1/2 sm:mb-0 mb-3"
                  :format="'dd/MM/yyyy'"
                  placeholder="Data inicial"
                  v-model="formFiltro.dataInicial"
                  @input="dateFinalAnterior"
                  ><p slot="beforeCalendarHeader" class="pt-2 text-center">
                    DATA INICIAL
                  </p></datepicker
                >

                <datepicker
                  calendar-class="right-0"
                  use-utc
                  class="w-1/2 sm:mb-0 mb-3"
                  :format="'dd/MM/yyyy'"
                  placeholder="Data Final"
                  v-model="formFiltro.dataFinal"
                  @input="dateInicialAnterior"
                  ><p slot="beforeCalendarHeader" class="pt-2 text-center">
                    DATA FINAL
                  </p></datepicker
                >
              </div>
            </div>
          </div>
        </div>
        <div class="filtroConsolidado vx-row pl-4 pr-4">
          <div class="vx-col lg:w-3/5 w-full">
            <vs-checkbox
              class="mb-4"
              v-model="formFiltro.editarPeriodoAnterior"
            >
              Editar período anterior
            </vs-checkbox>
            <div class="vx-col justify-between gerar sm:flex gap-4 w-full mt-2">
              <div class="vx-col relative flex gap-4 w-full">
                <datepicker
                  v-if="formFiltro.editarPeriodoAnterior"
                  use-utc
                  icon="icon-arrow-right"
                  class="w-1/2 sm:mb-0 mb-3"
                  :format="'dd/MM/yyyy'"
                  placeholder="Data inicial"
                  v-model="formFiltro.dataInicialAnterior"
                  ><p slot="beforeCalendarHeader" class="pt-2 text-center">
                    DATA INICIAL ANTERIOR
                  </p></datepicker
                >

                <datepicker
                  v-if="formFiltro.editarPeriodoAnterior"
                  calendar-class="right-0"
                  use-utc
                  class="w-1/2 sm:mb-0 mb-3"
                  :format="'dd/MM/yyyy'"
                  placeholder="Data Final"
                  v-model="formFiltro.dataFinalAnterior"
                  ><p slot="beforeCalendarHeader" class="pt-2 text-center">
                    DATA FINAL ANTERIOR
                  </p></datepicker
                >
              </div>
            </div>
          </div>
          <div class="vx-col lg:w-1/5 w-full">
            <vs-checkbox
              class="mb-4"
              v-model="formFiltro.utilizarDataFinalizacaoReal"
            >
              Data de Adesão Real
            </vs-checkbox>
          </div>
          <div class="vx-col lg:w-1/5 w-full text-rigth">
            <vs-button
              :disabled="
                !$can('Leitura Carteira Completa', 'Associados') &&
                !$can('Leitura Carteira Corretora', 'Associados')
              "
              color="#038803"
              type="filled"
              icon-pack="feather"
              icon="icon-arrow-right"
              icon-after
              class="pt-4 pb-4 mb-2 mt-2 sm:mt-0 sm:w-auto w-full btn-block"
              native-type="submit"
              >Gerar</vs-button
            >
          </div>
        </div>
      </form>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import ability from '../../services/ability';
import jwt from 'jsonwebtoken';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },

  data() {
    return {
      idEmpresa: +localStorage.getItem('idEmpresa'),
      divisoes: [],
      regionais: [],
      consultores: [],
      languages: lang,
      formFiltro: {
        idEmpresa: +localStorage.getItem('idEmpresa'),
        dataInicial: null,
        dataFinal: null,
        dataInicialAnterior: null,
        dataFinalAnterior: null,
        divisao: '',
        regional: '',
        editarPeriodoAnterior: false,
        utilizarDataFinalizacaoReal: true,
      },
    };
  },

  methods: {
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 30);
      return b;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          const token = localStorage.getItem('user-token');
          const decoded = jwt.decode(token);
          const permissoes = ability.getPermission().$;
          const carteiraRegional = permissoes.filter(
            (item) =>
              item.subject == 'Associados' &&
              item.action == 'Leitura Carteira Corretora',
          );
          const regionais = [];
          decoded.regionais.map((item) => {
            regionais.push(item.id_regional);
          });
          regionais.push(decoded.id_regional);
          if (array == 'regionais' && carteiraRegional.length > 0) {
            res.data.forEach((element) => {
              if (regionais.includes(element[campoPK])) {
                element.id = element[campoPK];
                element.label = element[campoDescricao];
                if (!element.deletedAt) this[array].push(element);
              }
            });
          } else {
            res.data.forEach((element) => {
              element.id = element[campoPK];
              element.label = element[campoDescricao];
              if (!element.deletedAt) this[array].push(element);
            });
            if (array == 'divisoes') {
              if (decoded.id_divisao) {
                this.formFiltro.divisao = this.divisoes.find(
                  (x) => x.idDivisao == decoded.id_divisao,
                );
              }
            }
          }
        });
    },

    buscaDadosRegionais() {
      if (this.formFiltro.divisao.idDivisao) {
        this.regionais = [];
        this.$vs.loading();
        service
          .post('Regional', `BuscarRegionalPorDivisao`, {
            idEmpresa: this.idEmpresa,
            idDivisao: this.formFiltro.divisao.idDivisao,
          })
          .then((res) => {
            const token = localStorage.getItem('user-token');
            const decoded = jwt.decode(token);
            const permissoes = ability.getPermission().$;
            const carteiraRegional = permissoes.filter(
              (item) =>
                item.subject == 'Associados' &&
                item.action == 'Leitura Carteira Corretora',
            );
            const regionais = [];
            decoded.regionais.map((item) => {
              regionais.push(item.id_regional);
            });
            regionais.push(decoded.id_regional);
            if (carteiraRegional.length > 0) {
              res.data.forEach((element) => {
                if (regionais.includes(element.id_regional)) {
                  element.id = element.id_regional;
                  element.label = element.nome;
                  if (!element.deletedAt) this.regionais.push(element);
                }
              });
            } else {
              res.data.forEach((element) => {
                element.id = element.id_regional;
                element.label = element.nome;
                if (!element.deletedAt) this.regionais.push(element);
              });
            }
            this.$vs.loading.close();
          });
      }
    },
    buscaDadosConsultor() {
      if (this.formFiltro.regional && this.formFiltro.regional.length >= 1) {
        this.consultores = [];
        this.$vs.loading();
        const regionais = [];
        this.formFiltro.regional.forEach((element) => {
          regionais.push(element.id_regional);
        });
        service
          .post('Usuario', 'busca-consultores-por-regional', {
            idRegionais: regionais,
          })
          .then((res) => {
            res.data.forEach((element) => {
              element.id = element.id_usuario;
              element.label = element.nome;
              this.consultores.push(element);
            });
            this.$vs.loading.close();
          });
      } else {
        this.consultores = [];
      }
    },
    dateInicialAnterior() {
      const dataInicialMoment = moment(
        this.formFiltro.dataInicial,
        'YYYY-MM-DD',
      );
      const dataFinalMoment = moment(this.formFiltro.dataFinal, 'YYYY-MM-DD');
      const diferencaDias = dataFinalMoment.diff(dataInicialMoment, 'days');

      this.formFiltro.dataInicialAnterior = dataInicialMoment
        .clone()
        .subtract(diferencaDias, 'days')
        .format('YYYY-MM-DD');
    },
    dateFinalAnterior() {
      const dataInicialMoment = moment(
        this.formFiltro.dataInicial,
        'YYYY-MM-DD',
      );

      this.formFiltro.dataFinalAnterior = dataInicialMoment
        .clone()
        .subtract(1, 'days')
        .format('YYYY-MM-DD');
    },

    preparaDatas() {
      this.formFiltro.dataInicial = moment()
        .startOf('month')
        .format('YYYY-MM-DD');
      this.formFiltro.dataFinal = moment().endOf('month').format('YYYY-MM-DD');

      const dataInicialMoment = moment(
        this.formFiltro.dataInicial,
        'YYYY-MM-DD',
      );
      const dataFinalMoment = moment(this.formFiltro.dataFinal, 'YYYY-MM-DD');

      const diferencaDias = dataFinalMoment.diff(dataInicialMoment, 'days');

      this.formFiltro.dataInicialAnterior = dataInicialMoment
        .clone()
        .subtract(diferencaDias, 'days')
        .format('YYYY-MM-DD');

      this.formFiltro.dataFinalAnterior = dataInicialMoment
        .clone()
        .subtract(1, 'days')
        .format('YYYY-MM-DD');
    },

    buscar() {
      this.formFiltro.idEmpresa = this.idEmpresa;
      this.$emit('filtro', this.formFiltro);
    },
  },
  mounted() {
    this.preparaDatas();
    this.buscaDadosSelects('divisoes', 'divisoes', 'nomeDivisao', 'idDivisao');
    //this.buscaDadosSelects('regionais', 'regionais', 'nome', 'idRegional');
    if (
      this.$can('Leitura Carteira Completa', 'Associados') ||
      this.$can('Leitura Carteira Corretora', 'Associados')
    ) {
      //this.buscar();
    }
  },
  components: {
    Datepicker,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.labelFiltro {
  font-size: 14px;
  color: black;
}
.filtroConsolidado .vs__dropdown-toggle {
  padding: 7px 0 !important;
  border-radius: 10px;
  font-size: 14px;
}

.filtroConsolidado .vdp-datepicker input {
  width: 100%;
  padding: 1rem 0.7rem;
  border-radius: 10px;
}

.filtroConsolidado .vdp-datepicker__calendar {
  z-index: 900 !important;
}
.gerar .vs-button {
  border-radius: 14px;
}

.vs__dropdown-menu {
  top: inherit !important;
}
</style>
